import { render, staticRenderFns } from "./ConfigurationsView.vue?vue&type=template&id=fe1bfba4&"
import script from "./ConfigurationsView.vue?vue&type=script&lang=js&"
export * from "./ConfigurationsView.vue?vue&type=script&lang=js&"
import style0 from "./ConfigurationsView.vue?vue&type=style&index=0&id=fe1bfba4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports